module.exports = __webpack_public_path__ + "img/dialog-code.png";